import "./JobList.scss";
import ContentCreatorSidebar from "../../../components/sidebars/ContentCreatorSidebar";
import React, {useEffect, useState} from "react";
import {useAuth} from "../../../context/AuthContext";
import Navbar from "../../../components/Navbar";
import CardCollection from "../../../components/cards/CardCollection";

const JobList = () => {

  const [rows, setRows] = useState([]);

  const { authUser } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetch('https://europe-west6-kareerr-7415c.cloudfunctions.net/getJobs',
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + authUser.accessToken,
              "Access-Control-Allow-Origin" : "*"
            },
            method: "POST"
          });
      return await result.json();
    }
    fetchData().then(result => setRows(result));
  }, []);

  return (
      <div className="job-list">
        <Navbar />
        <div className="job-list-container">
          <ContentCreatorSidebar />
          <div className="job-list-body">
            <CardCollection type="roundedJobsCard" cards={rows} needsSplit={true} />
          </div>
        </div>
      </div>
  )
}

export default JobList;